import React from 'react';

// Public teaser for the native ATS/CRM while it's user-1 gated. Shown to
// everyone else from the sidebar's ATS / CRM entry.
const AtsComingSoon: React.FC = () => (
  <div className="max-w-2xl mx-auto px-6 py-16">
    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm px-10 py-12 text-center">
      <span className="inline-flex items-center px-3 py-1 rounded-full text-[11px] font-semibold bg-emerald-50 text-emerald-700 ring-1 ring-inset ring-emerald-600/20 uppercase tracking-wide mb-5">
        Coming soon
      </span>
      <h1 className="text-2xl font-bold text-gray-900 mb-3">Your ATS & CRM, built in</h1>
      <p className="text-sm text-gray-500 leading-relaxed mb-8">
        Run your whole desk where your market lives: clients, roles and pipelines,
        placements and fees, synced email and calendar with AI triage, and records
        that stay alive because they're connected to your mapped data.
      </p>
      <div className="grid sm:grid-cols-3 gap-4 text-left">
        {[
          { h: 'ATS', d: 'Candidates, role pipelines, placements with fees — drag to stage, revenue tracks itself.' },
          { h: 'CRM', d: 'Clients and contacts enriched automatically, with every note, email and meeting on the record.' },
          { h: 'Workspace', d: 'Inbox with AI noise filtering, follow-up suggestions, tasks and your meeting calendar.' },
        ].map((f) => (
          <div key={f.h} className="rounded-xl bg-emerald-500/5 px-4 py-3.5">
            <p className="text-sm font-semibold text-emerald-900">{f.h}</p>
            <p className="text-xs text-gray-500 mt-1">{f.d}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default AtsComingSoon;
